<div [formGroup]="form" class="ach-verify">
  <p class="ach-verify__intro">
    Enter the account number you believe is on file. It is encrypted in your browser
    before being sent and is only compared against the stored account &mdash; the
    account on file is never shown.
  </p>

  <div class="ach-verify__context">
    <span class="ach-verify__context-label">Account on file</span>
    <span class="ach-verify__context-value">{{ redactedAccount }}</span>
  </div>

  <div class="ach-verify__notice" *ngIf="!accountVerifiable">
    <mat-icon>info_outline</mat-icon>
    <span>
      This account was stored before full verification was available. Only the last
      4 digits can be checked. Re-add the account to enable full verification.
    </span>
  </div>

  <div class="ach-verify__field">
    <mat-form-field appearance="outline">
      <mat-label>Account Number</mat-label>
      <input
        matInput
        type="password"
        formControlName="account"
        autocomplete="off"
        autocapitalize="off"
        spellcheck="false"
        inputmode="numeric"
        maxlength="17"
      />
      <mat-error>
        @if (form.controls.account.hasError('required')) {
          Account Number is required.
        }
        @if (form.controls.account.hasError('minlength')) {
          Must be at least 5 digits.
        }
        @if (form.controls.account.hasError('maxlength')) {
          Cannot exceed 17 digits.
        }
        @if (form.controls.account.hasError('pattern')) {
          Only numbers allowed.
        }
      </mat-error>
    </mat-form-field>
  </div>

  <div class="ach-verify__status" *ngIf="statusMessage">
    <mat-icon>error_outline</mat-icon>
    <span>{{ statusMessage }}</span>
  </div>
</div>
